import { render } from "./p-secure.vue?vue&type=template&id=f66eecb0"
import script from "./p-secure.vue?vue&type=script&lang=js"
export * from "./p-secure.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__